import {Component, Input, OnInit} from '@angular/core';
import {Context, Size} from '../enums';

@Component({
  selector: 'hxa-loader, hxa-loaders',
  template: `<div class="hx-loader"
     [class.is-small]="size === sizeEnum.Small"
     [class.is-primary]="context === contextEnum.Success"
     [class.is-warning]="context === contextEnum.Warning"
     [class.is-danger]="context === contextEnum.Danger"
     [class.is-info]="context === contextEnum.Info"><div></div><div></div><div></div><div></div></div>
`,
  styles: [``]
})
export class LoadersComponent implements OnInit {

  @Input()
  size: Size = Size.Default;

  @Input()
  context: Context = Context.None;

  /** Enums to be used in the template **/
  contextEnum = Context;
  sizeEnum = Size;

  constructor() { }

  ngOnInit() {
  }

}
